/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import { Card, CardContent, Skeleton, SkeletonLine } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useContainerWidth } from '../../hooks/useContainerWidth';
import { defaultCardContentProps } from '../../constants/responsiveClassNames';

const ListsSkeleton = () => {
  const [ref, containerWidth] = useContainerWidth();
  const isMobile = containerWidth < 570;

  return (
    <Card
      data-component="Lists"
      data-testid="lists-skeleton-container"
      className="sui-@container sui-w-full sui-h-full"
      ref={ref}
    >
      <CardContent>
        <Skeleton grow disablePadding>
          <SkeletonLine variant="single" />
        </Skeleton>
        <div className={`sui-grid sui-grid-cols-${isMobile ? '1' : '2'}`}>
          <Skeleton grow disablePadding>
            <SkeletonLine variant="multi" numberOfLines={3} />
          </Skeleton>
          <Skeleton grow disablePadding>
            <SkeletonLine variant="multi" numberOfLines={3} />
          </Skeleton>
        </div>
        <Skeleton grow disablePadding>
          <SkeletonLine variant="single" />
        </Skeleton>
      </CardContent>
    </Card>
  );
};

export default ListsSkeleton;